document.addEventListener("DOMContentLoaded", () => {
  // Desktop only
  const mq = window.matchMedia("(min-width: 990px)");
  if (!mq.matches) return;

  // Dawn dropdown uses <details> in the inline menu
  document.querySelectorAll(".header__inline-menu details").forEach((details) => {
    let closeTimer;

    details.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
      details.setAttribute("open", "open"); // force open
    });

    details.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(() => {
        details.removeAttribute("open");
      }, 150);
    });
  });
});
